import Container from "containers/anx1/SharedModule/DropdownTreeContainer";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "../style.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getGstinByEntity,
  profileInfo,
  setDefaultEntity,
  setEntityLabel,
  setPeriodStore,
  setPeriodStoreSingle,
  storeSelectedGstinGSTR2A2BNEW,
} from "../action";
import { InputLabel } from "@material-ui/core";
import DatePicker from "react-datepicker";
import { recoType } from "../Reconciliation/constants";
import CustomSelect from "./CustomSelect";
import SingleSelect from "components/Select/SingleSelect";
import { setRecoSelection } from "../Reconciliation/action";
const Gstr2a2bFilter = ({ entityMasterList, profileData, activeTab, flag,handleRecoTypeFilter,recoSelection,retPeriodWidth }) => {
  const dispatch = useDispatch();
  const storePeriod = useSelector(
    (store) => store.gstr2a2bNewCommonReducer.selectedPeriodSingle
  );

  const storeGstinGSTR2A2BNEW = useSelector(
    (store) => store.gstr2a2bNewCommonReducer.selectedGstin
  );
  const defaultEntity = useSelector(
    (store) => store.gstr2a2bNewCommonReducer.defaultEntity
  );
  const startDateStore = useSelector(
    (store) => store.gstr2a2bNewCommonReducer.startDate
  );
  const endDateStore = useSelector(
    (store) => store.gstr2a2bNewCommonReducer.endDate
  );
  const [selectedPeriodSingle, setSelectedPeriodSingle] = useState(null);

  const [profile, setProfile] = useState([]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startYear, setStartYear] = useState(new Date());
  useEffect(() => {
    setStartDate(startDateStore);
    setEndDate(endDateStore);
  }, []);

  const handleChange = ([newStartDate, newEndDate]) => {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    dispatch(setPeriodStore(newStartDate, newEndDate));
  };
  const handleInputChange = (e) => {
    e.preventDefault();
  };
  const getEntityMasterList = () => {
    const result = entityMasterList?.map((item) => {
      if (item?.value && defaultEntity)
        item.checked = item.value === defaultEntity;
      return item;
    });
    console.log("getEntityMasterList result:", result);
    return result;
  };
  // async function handleEntity(currentNode, selectedNode) {
  //   dispatch(setDefaultEntity(selectedNode[0]?.value || ""));
  //   if (selectedNode.length && selectedNode[0]?.value) {
  //     let gstinList = await dispatch(getGstinByEntity(selectedNode[0]?.value));
  //     let allGstinList = gstinList?.map((item) => item?.gstin);

  //     dispatch(storeSelectedGstinGSTR2A2BNEW(allGstinList));
  //   } else {
  //     await dispatch(profileInfo([]));
  //     dispatch(storeSelectedGstinGSTR2A2BNEW([]));
  //   }
  // }
//  async function handleEntity(value) {
//     dispatch(setDefaultEntity(value || ""));
//     if (value) {
//       let gstinList = await dispatch(getGstinByEntity(value));
//       let allGstinList = gstinList?.map((item) => item.gstin);

   
//     } else {
//       await dispatch(profileInfo([]));
//       dispatch(storeSelectedGstinGSTR2A2BNEW([]));
//     }
//   }

  async function handleEntity(value) {
  try {
    console.log('value in handleEntity:: ',value)
    dispatch(setDefaultEntity(value || ""));
    // Find the selected entity object and store its label
    const selectedObj = entityMasterList?.find(item => String(item.value) === String(value));
    dispatch(setEntityLabel(selectedObj?.label || ""));
    // setSelectedEntityLabel(selectedObj?.label || "");
    console.log('selectedObj in handleEntity:: ',selectedObj)
    if (value) {
      let gstinList = await dispatch(getGstinByEntity(value));
      let allGstinList = gstinList?.map((item) => item?.gstin);

       dispatch(storeSelectedGstinGSTR2A2BNEW(allGstinList));
    } else {
      await dispatch(profileInfo([]));
      dispatch(storeSelectedGstinGSTR2A2BNEW([]));
    }
  } catch (error) {
    console.log("Error in handleEntity:", error);
  }
}

  useEffect(() => {
    let newProfile =
      profileData?.length > 0
        ? profileData.map((v) => ({ ...v, label: v.gstin, value: v.gstin }))
        : [];

    const AllProfile = [
      {
        label: "All GSTIN",
        value: "All GSTIN",
        checked: newProfile.length > 0,
        tagClassName: "special",
        children: newProfile,
      },
    ];
    setProfile(AllProfile);
  }, [profileData]);

  async function handleGstin(currentNode, selectedNodes) {
    let gstArr = [];
    if (selectedNodes[0]?.label === "All GSTIN") {
      var newProfile =
        profileData.length > 0
          ? profileData.map((v) => ({
              ...v,
              label: v.gstin || v.GSTIN,
              value: v.gstin || v.GSTIN,
            }))
          : [];
      gstArr = newProfile?.map((item) => {
        return item.gstin;
      });
    } else {
      gstArr = selectedNodes.map((item) => {
        return item.gstin || item.GSTIN;
      });
    }
    dispatch(storeSelectedGstinGSTR2A2BNEW(gstArr));
  }

  const handlePeriodChange = (selectedDate) => {
    let mnth = ("0" + (selectedDate.getMonth() + 1)).slice(-2);
    let yr = selectedDate.getFullYear();
    let period = mnth + "-" + yr;
    dispatch(setPeriodStoreSingle(period));
    setSelectedPeriodSingle(selectedDate);
  };

useEffect(() => {
  if (startDateStore === null && endDateStore === null) {
    console.log('Resetting dates as store values are null');
    setStartDate(null);
    setEndDate(null);
    setSelectedPeriodSingle(null); // If you use this for single period
  }
}, [startDateStore, endDateStore]);

  return (
    <div>
      <form>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="dropdown-container-gstr2a2b" style={{ width: "32%" }}>
            <label
              style={{
                fontFamily: "GT-Walsheim-medium",
                fontSize: "12px",
                lineHeight: "16px",
                minHeight: "16px",
                marginBottom: "6px",
                display: "block",
              }}
            >
              Select Entity *
            </label>

            {/* <Container
              data={getEntityMasterList()}
              mode="simpleSelect"
              onChange={handleEntity}
            /> */}
            <SingleSelect
            values={getEntityMasterList()}
            optionHeading={"Select"}
            selectedValue={defaultEntity}
            handleChange={(e) => handleEntity(e.target.value)}
          />
          </div>
          <div className="dropdown-container-gstr2a2b" style={{ width: "32%",zIndex:101 }}>
            <label
              style={{
                fontFamily: "GT-Walsheim-medium",
                fontSize: "12px",
                lineHeight: "16px",
                minHeight: "16px",
                marginBottom: "6px",
                display: "block",
              }}
            >
              Select GSTIN *
            </label>
            <Container
              data={profile?.map((item) => {
                if (
                  storeGstinGSTR2A2BNEW &&
                  Array.isArray(storeGstinGSTR2A2BNEW) &&
                  storeGstinGSTR2A2BNEW.length > 0
                ) {
                  if (
                    item.children &&
                    item.children.length !== storeGstinGSTR2A2BNEW.length
                  ) {
                    item.checked = false;

                    item.children = item.children.map((chItem) => {
                      chItem.checked = storeGstinGSTR2A2BNEW.find(
                        (x) => x === chItem.gstin || x === chItem.GSTIN
                      )
                        ? true
                        : false;
                      return chItem;
                    });
                  }
                }

                return item;
              })}
              onChange={handleGstin}
              isDisabled={profileData.length === 0}
            />
          </div>
          {!flag && (
            <div
              style={{ paddingTop: "0.63em", width: retPeriodWidth ? retPeriodWidth : "33%",zIndex:100 }}
              className="gstr2a2bDatePicker"
            >
              <InputLabel
                id="demo-simple-select-autowidth-label"
                className="text_label"
                style={{
                  fontFamily: "GT-Walsheim-medium",
                  fontSize: "12px",
                  color: "black",
                  top: "10px",
                }}
              >
                Select Period *
              </InputLabel>
              {activeTab != "3" ? (
                <DatePicker
                  selected={startDate}
                  onChange={handleChange}
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  maxDate={new Date()}
                  onKeyDown={handleInputChange} // Handle any key press
                  onKeyPress={handleInputChange}
                  placeholderText="Select Period *"
                />
              ) : (
                <DatePicker
                  selected={selectedPeriodSingle}
                  onChange={handlePeriodChange}
                  value={storePeriod}
                  placeholderText="Select Period *"
                  dateFormat="MM-yyyy"
                  showMonthYearPicker
                  showFullMonthYearPicker
                  maxDate={new Date()}
                  onKeyDown={handleInputChange} // Handle any key press
                  onKeyPress={handleInputChange}
                />
              )}
            </div>
          )}
          {flag === "reconciliationTab" && (
            <div
                      style={{ width: "29%",zIndex:100 }}
                      className="dropdown-container-gstr2a2b"
                    >
                      <InputLabel
                        id="demo-simple-select-autowidth-label"
                        className="text_label"
                        style={{
                          fontFamily: "GT-Walsheim-medium",
                          fontSize: "12px",
                          color: "black",
                          lineHeight: "16px",
                          minHeight: "16px",
                          marginBottom: "6px",
                          display: "block",
                        }}
                      >
                        Select Reco Type *
                      </InputLabel>
                      {/* <Container data={recoType} onChange={handleRecoTypeFilter}  mode="simpleSelect"/> */}
                      <CustomSelect
                                values={recoType}
                                optionHeading={'Select Reco Type'}
                                selectedValue={recoSelection}
                                handleChange={handleRecoTypeFilter}
                                setSelectedValue={setRecoSelection}
                                />
                    </div>
            // <div
            //   style={{ paddingTop: "0.63em", width: "29%" }}
            //   className="gstr2a2bDatePicker"
            // >
            //   <InputLabel
            //     id="demo-simple-select-autowidth-label"
            //     className="text_label"
            //     style={{
            //       fontFamily: "GT-Walsheim-medium",
            //       fontSize: "12px",
            //       color: "black",
            //       top: "10px",
            //     }}
            //   >
            //     Select Financial Year *
            //   </InputLabel>
            //   <DatePicker
            //     selected={startYear}
            //     onChange={(date) => setStartYear(date)}
            //     showYearPicker
            //     dateFormat="yyyy"
            //   />
            // </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default Gstr2a2bFilter;
